import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const Image = styled('img')(() => ({
  height: 18,
  width: 18,
  aspectRatio: '1 / 1',
  objectFit: 'contain',
}));

interface Props {
  label: string;
  url: string;
}

export function ImageMediaCell({ label, url }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
      }}
    >
      {url && <Image src={url} />}
      <Box
        title={label}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </Box>
    </Box>
  );
}
